import React from 'react'
import PeopleForm from './PeopleForm'
import CountriesForm from './CountriesForm'
import CampsForm from './CampsForm'
import SourcesForm from './SourcesForm'
import BoardForm from './BoardForm'
import ManagerForm from './ManagerForm'
import LeitungsEbene from './LeitungsEbene'
import Arolsen_Archives from './Arolsen_Archives'
import DocumentsPeopleForm from './DocumentsPeopleForm'

const AllForms = () => {
    return (

        <>
            <h1>All Forms</h1>
            <PeopleForm />
            <CountriesForm />
            <CampsForm />
            <SourcesForm />
            <BoardForm />
            <ManagerForm />
            <LeitungsEbene />
            <Arolsen_Archives />
            <DocumentsPeopleForm />

        </>

    )
}

export default AllForms